import get from 'lodash/get';
import { requestGet } from '../../../services/real.backend';
import authStorage from '../../mobx/authStorage';
import { API_GET_CURRENT_USER } from '../../../services/apiPoints';

export default function getUserAuthState() {
  return new Promise((resolve, reject) => requestGet(API_GET_CURRENT_USER)
    .then((resp) => {
      const profile = get(resp, 'profile', -1);
      // Здесь нужно проверить данные и их сохранить. Потом переход на дашборд
      if (profile != -1) {
        authStorage.setCredientials(resp.profile);
        resolve(true);
      } else {
        resolve(false);
      }
      // reject(new Error('User not authentificated'));
    })
    .catch((e) => reject(e)));
}
